import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Barcode, Search } from "lucide-react";
import { NeuInput } from "../../components/neu/Neu";

// جدول بنود الجرد: بحث · سكانر باركود · إدخال الرصيد الفعلي مع تلوين الفرق.
export const CountSheet = ({ lines, onChange, readOnly, currency = "IQD" }) => {
  const { t, i18n } = useTranslation();
  const [term, setTerm] = useState("");
  const [scan, setScan] = useState("");
  const num = (n) => new Intl.NumberFormat(i18n.language, { maximumFractionDigits: 2 }).format(n || 0);

  const filtered = term ? lines.filter((l) =>
    (l.item_name || "").toLowerCase().includes(term.toLowerCase()) ||
    (l.item_code || "").toLowerCase().includes(term.toLowerCase())) : lines;

  const patch = (item_id, patch_obj) =>
    onChange(lines.map((l) => l.item_id === item_id ? { ...l, ...patch_obj } : l));

  const onScan = (e) => {
    if (e.key !== "Enter" || !scan.trim()) return;
    const code = scan.trim();
    const match = lines.find((l) => (l.item_code || "").toLowerCase() === code.toLowerCase());
    if (!match) return alert(t("warehouse.count.notInSheet", { code }));
    patch(match.item_id, { counted_qty: (Number(match.counted_qty) || 0) + 1 });
    setScan("");
  };

  return (
    <div className="grid gap-3" data-testid="count-sheet">
      <div className="grid gap-2 sm:grid-cols-2">
        <div className="relative">
          <Search className="absolute top-3 h-4 w-4 text-muted-foreground ltr:left-3 rtl:right-3" />
          <NeuInput data-testid="cnt-search" value={term} placeholder={t("warehouse.count.searchItem")}
                    onChange={(e) => setTerm(e.target.value)} className="pl-10 rtl:pl-3 rtl:pr-10" />
        </div>
        {!readOnly && (<div className="relative">
          <Barcode className="absolute top-3 h-4 w-4 text-teal-600 ltr:left-3 rtl:right-3" />
          <NeuInput data-testid="cnt-scan" value={scan} placeholder={t("warehouse.count.scanHint")}
                    onChange={(e) => setScan(e.target.value)} onKeyDown={onScan}
                    className="pl-10 rtl:pl-3 rtl:pr-10 border border-teal-500/40" /></div>)}
      </div>
      <div className="max-h-[520px] overflow-y-auto rounded-2xl shadow-neu-in">
        <table className="w-full text-xs" data-testid="cnt-table">
          <thead className="sticky top-0 bg-primary/10 text-[10px]">
            <tr>{["no", "item", "uom", "sys", "counted", "variance", "note"].map((k) =>
              <th key={k} className="p-2 text-start font-bold">{t(`warehouse.count.cols.${k}`)}</th>)}</tr>
          </thead>
          <tbody>
            {filtered.map((l, i) => {
              const cq = l.counted_qty; const sq = Number(l.system_qty) || 0;
              const v = cq === null || cq === undefined ? null : Number(cq) - sq;
              const color = v === null ? "text-muted-foreground" : v === 0
                ? "text-emerald-600" : v > 0 ? "text-sky-600" : "text-rose-600";
              return (
                <tr key={l.item_id} className="border-b border-border/30">
                  <td className="p-2 text-[10px] text-muted-foreground">{i + 1}</td>
                  <td className="p-2"><p className="font-bold">{l.item_name}</p>
                    <p className="num font-mono text-[10px] text-muted-foreground">{l.item_code}</p></td>
                  <td className="p-2 text-[11px]">{l.uom || "—"}</td>
                  <td className="p-2 num font-mono">{num(sq)}</td>
                  <td className="p-2 w-24">
                    {readOnly ? <span className="num font-mono font-bold">{num(cq)}</span>
                      : <NeuInput dir="ltr" type="number" data-testid={`cnt-qty-${l.item_id}`}
                                  value={cq === null || cq === undefined ? "" : cq}
                                  onChange={(e) => patch(l.item_id,
                                    { counted_qty: e.target.value === "" ? null : Number(e.target.value) })}
                                  className="h-8 text-center" />}</td>
                  <td className={`p-2 num font-mono font-bold ${color}`}>
                    {v === null ? "—" : (v > 0 ? "+" : "") + num(v)}</td>
                  <td className="p-2 w-32">
                    {readOnly ? <span className="text-[10px]">{l.note || "—"}</span>
                      : <NeuInput data-testid={`cnt-note-${l.item_id}`} value={l.note || ""}
                                  onChange={(e) => patch(l.item_id, { note: e.target.value })}
                                  className="h-8 text-[11px]" />}</td>
                </tr>);
            })}
          </tbody>
        </table>
      </div>
      <p className="text-[10px] text-muted-foreground">{t("warehouse.count.currency")}: {currency}</p>
    </div>
  );
};
